import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetInvestigationDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Investigation/GetDetail?` + params, null);

export const GetInvestigationList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Investigation/GetList?` + params, null);

export const CreateInvestigation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Investigation/Create`, data);

export const UpdateInvestigation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Investigation/Update`, data);

export const DeleteInvestigation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Investigation/Delete`, data);